import React, { useEffect, useMemo } from 'react';
import clsx from 'clsx';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import MultiselectDropdownNew from '../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';
import useActiv8TagsOptions from '../../../hooks/useActiv8TagsOptions';
import { Input } from '../../../../components/common-inputs';
import { useProject } from '../../../../context/ProjectContext';
import { PROJECT_VARIANTS } from '../../../../constants';

import scss from './AdditionalFilters.module.scss';

function AdditionalFilters({ localSelectedFilters, onChangeLocalSelectedFilters }) {
  const { t } = useTranslation('activ8');
  const { actions, projectVariant } = useProject();
  const { id } = useParams();

  const tagsOptions = useActiv8TagsOptions();
  const isAdmin = projectVariant === PROJECT_VARIANTS.ADMIN;

  const { contentUsers, isContentUsersLoading } = useSelector((state) => state.activ8);

  const usernameOptions = useMemo(
    () => [{ label: t('all'), value: '' }, ...contentUsers.map((username) => ({ label: username, value: username }))],
    [contentUsers, t],
  );

  const handleChangeTags = (tags) => {
    onChangeLocalSelectedFilters({ ...localSelectedFilters, tags });
  };

  const handleChangeNegativeQuery = (negativeQuery) => {
    onChangeLocalSelectedFilters({ ...localSelectedFilters, negativeQuery: [negativeQuery] });
  };

  const handleChangeUsername = (username) => {
    onChangeLocalSelectedFilters({
      ...localSelectedFilters,
      username: username ? [{ label: username, value: username }] : [],
    });
  };

  const handleSearchTags = (search) => {
    actions('searchTags', { id, query: search });
  };

  useEffect(() => {
    actions('searchTags', { id, query: '' });
    if (isAdmin) {
      actions('getContentUsers', { id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isAdmin]);

  return (
    <div className={scss.filtersGrid}>
      <div className={clsx(scss.filterWrapper, !isAdmin && scss.fullWidth)}>
        <h4 className={scss.title}>{t('exclude')}</h4>
        <Input
          name='negativeQuery'
          type='text'
          value={localSelectedFilters.negativeQuery || ''}
          onChange={handleChangeNegativeQuery}
          placeholder={t('negativeQuery')}
          size='sm'
        />
      </div>
      {isAdmin ? (
        <div className={scss.filterWrapper}>
          <h4 className={scss.title}>{t('username')}</h4>
          <CommonDropdown
            options={usernameOptions}
            value={localSelectedFilters.username?.[0]?.value || ''}
            onSelect={handleChangeUsername}
            placeholder={t('selectUsername')}
            isLoading={isContentUsersLoading}
            isFilterable
          />
        </div>
      ) : null}
      <div className={clsx(scss.filterWrapper, scss.fullWidth)}>
        <h4 className={scss.title}>{t('tags')}</h4>
        <MultiselectDropdownNew
          options={tagsOptions}
          value={localSelectedFilters.tags || []}
          onChange={handleChangeTags}
          placeholder={t('selectTags')}
          onSearch={handleSearchTags}
          isDebounce
          disableNewOptions
        />
      </div>
    </div>
  );
}

export default AdditionalFilters;
